import React from 'react';
import colors from '../../../theme/color';

interface LoadingScreenProps {
    className?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ className = '' }) => {
    return (
        <div className={`flex items-center justify-center min-h-screen ${className} bg-blackDark`}>
            <div className="relative">
                {/* Outer ring */}
                <div className="w-24 h-24 border-4 border-t-transparent border-blue rounded-full animate-spin"></div>

                {/* Inner dots */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex space-x-1">
                    {[colors.yellow, colors.green, colors.purple].map((color, index) => (
                        <div
                            key={index}
                            className="w-5 h-5 rounded-full animate-bounce"
                            style={{
                                backgroundColor: color,
                                animationDelay: `${index * 0.2}s`
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen; 